import { CalculatorDescription } from '../../../lib/calculators/calculator-description';
import { CalculatorId } from '../../../lib/calculators/calculator-config';

export const columnGraphDescription: CalculatorDescription = {
  id: CalculatorId.ColumnChart,
  title: 'Column Chart Maker',
  metaTitle: 'Free Online Column Chart Maker - Create Vertical Bar Graphs',
  description: 'Create vertical column charts to compare values across categories. Ideal for time series data, comparing quantities, and showing trends over different categories.',
  metaDescription: 'Make column charts online. Easy-to-use tool for creating vertical bar graphs. Compare data points and visualize trends with professional charts.',
  howTo: {
    title: 'How to Create a Column Chart',
    steps: [
      'Enter your categories and values',
      'Set column width and spacing',
      'Customize colors and styles',
      'Add title and labels',
      'Configure axis settings'
    ],
    graphic: {
      description: 'An echarts column chart with vertical bars, alongside a shadcn grid for data entry'
    }
  },
  examples: [
    {
      title: 'Monthly Sales',
      description: 'Time series data across months',
      dataDescription: 'Monthly sales performance data',
      insights: [
        'Shows sales performance over time',
        'Highlights peak sales months',
        'Enables year-over-year comparison',
        'Identifies seasonal patterns'
      ]
    },
    {
      title: 'Product Comparison',
      description: 'Categorical data across products',
      dataDescription: 'Product performance metrics',
      insights: [
        'Displays relative performance',
        'Shows market share',
        'Identifies top performers',
        'Enables product-to-product comparison'
      ]
    }
  ],
  relatedCalculators: [
    CalculatorId.BarGraph,
    CalculatorId.StackedBarChart,
    CalculatorId.HorizontalBarGraph
  ]
}; 